/* ui/game/PawnStats.svelte generated by Svelte v3.23.2 */
import {
	SvelteComponent,
	append,
	attr,
	component_subscribe,
	detach,
	element,
	empty,
	init,
	insert,
	noop,
	safe_not_equal,
	set_data,
	space,
	text
} from "svelte/internal";

import { hoveredPawnStore } from "../store";

function add_css() {
	var style = element("style");
	style.id = "svelte-16hcikk-style";
	style.textContent = ".container.svelte-16hcikk{display:grid;grid-template-columns:1fr 1fr}label.svelte-16hcikk{align-self:start}data.svelte-16hcikk{align-self:end}";
	append(document.head, style);
}

// (41:0) {:else}
function create_else_block(ctx) {
	let div;

	return {
		c() {
			div = element("div");
			div.textContent = "Hover over a pawn to see details";
		},
		m(target, anchor) {
			insert(target, div, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (20:0) {#if $hoveredPawnStore.id}
function create_if_block(ctx) {
	let div;
	let label0;
	let data0;
	let t1_value = /*$hoveredPawnStore*/ ctx[0].id + "";
	let t1;
	let t2;
	let label1;
	let data1;
	let t4_value = /*$hoveredPawnStore*/ ctx[0].owner + "";
	let t4;
	let t5;
	let label2;
	let data2;
	let t7_value = /*$hoveredPawnStore*/ ctx[0].x + "";
	let t7;
	let t8;
	let t9_value = /*$hoveredPawnStore*/ ctx[0].y + "";
	let t9;
	let t10;
	let t11;
	let t12;
	let t13;
	let t14;
	let if_block0 = /*$hoveredPawnStore*/ ctx[0].hp !== undefined && create_if_block_5(ctx);
	let if_block1 = /*$hoveredPawnStore*/ ctx[0].xp !== undefined && create_if_block_4(ctx);
	let if_block2 = /*$hoveredPawnStore*/ ctx[0].level !== undefined && create_if_block_3(ctx);
	let if_block3 = /*$hoveredPawnStore*/ ctx[0].attack !== undefined && create_if_block_2(ctx);
	let if_block4 = /*$hoveredPawnStore*/ ctx[0].readyToMerge !== undefined && create_if_block_1(ctx);

	return {
		c() {
			div = element("div");
			label0 = element("label");
			label0.textContent = "ID";
			data0 = element("data");
			t1 = text(t1_value);
			t2 = space();
			label1 = element("label");
			label1.textContent = "Owner";
			data1 = element("data");
			t4 = text(t4_value);
			t5 = space();
			label2 = element("label");
			label2.textContent = "x y";
			data2 = element("data");
			t7 = text(t7_value);
			t8 = text(",");
			t9 = text(t9_value);
			t10 = space();
			if (if_block0) if_block0.c();
			t11 = space();
			if (if_block1) if_block1.c();
			t12 = space();
			if (if_block2) if_block2.c();
			t13 = space();
			if (if_block3) if_block3.c();
			t14 = space();
			if (if_block4) if_block4.c();
			attr(label0, "class", "svelte-16hcikk");
			attr(data0, "class", "svelte-16hcikk");
			attr(label1, "class", "svelte-16hcikk");
			attr(data1, "class", "svelte-16hcikk");
			attr(label2, "class", "svelte-16hcikk");
			attr(data2, "class", "svelte-16hcikk");
			attr(div, "class", "container svelte-16hcikk");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, label0);
			append(div, data0);
			append(data0, t1);
			append(div, t2);
			append(div, label1);
			append(div, data1);
			append(data1, t4);
			append(div, t5);
			append(div, label2);
			append(div, data2);
			append(data2, t7);
			append(data2, t8);
			append(data2, t9);
			append(div, t10);
			if (if_block0) if_block0.m(div, null);
			append(div, t11);
			if (if_block1) if_block1.m(div, null);
			append(div, t12);
			if (if_block2) if_block2.m(div, null);
			append(div, t13);
			if (if_block3) if_block3.m(div, null);
			append(div, t14);
			if (if_block4) if_block4.m(div, null);
		},
		p(ctx, dirty) {
			if (dirty & /*$hoveredPawnStore*/ 1 && t1_value !== (t1_value = /*$hoveredPawnStore*/ ctx[0].id + "")) set_data(t1, t1_value);
			if (dirty & /*$hoveredPawnStore*/ 1 && t4_value !== (t4_value = /*$hoveredPawnStore*/ ctx[0].owner + "")) set_data(t4, t4_value);
			if (dirty & /*$hoveredPawnStore*/ 1 && t7_value !== (t7_value = /*$hoveredPawnStore*/ ctx[0].x + "")) set_data(t7, t7_value);
			if (dirty & /*$hoveredPawnStore*/ 1 && t9_value !== (t9_value = /*$hoveredPawnStore*/ ctx[0].y + "")) set_data(t9, t9_value);

			if (/*$hoveredPawnStore*/ ctx[0].hp !== undefined) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_5(ctx);
					if_block0.c();
					if_block0.m(div, t11);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (/*$hoveredPawnStore*/ ctx[0].xp !== undefined) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_4(ctx);
					if_block1.c();
					if_block1.m(div, t12);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if (/*$hoveredPawnStore*/ ctx[0].level !== undefined) {
				if (if_block2) {
					if_block2.p(ctx, dirty);
				} else {
					if_block2 = create_if_block_3(ctx);
					if_block2.c();
					if_block2.m(div, t13);
				}
			} else if (if_block2) {
				if_block2.d(1);
				if_block2 = null;
			}

			if (/*$hoveredPawnStore*/ ctx[0].attack !== undefined) {
				if (if_block3) {
					if_block3.p(ctx, dirty);
				} else {
					if_block3 = create_if_block_2(ctx);
					if_block3.c();
					if_block3.m(div, t14);
				}
			} else if (if_block3) {
				if_block3.d(1);
				if_block3 = null;
			}

			if (/*$hoveredPawnStore*/ ctx[0].readyToMerge !== undefined) {
				if (if_block4) {
					if_block4.p(ctx, dirty);
				} else {
					if_block4 = create_if_block_1(ctx);
					if_block4.c();
					if_block4.m(div, null);
				}
			} else if (if_block4) {
				if_block4.d(1);
				if_block4 = null;
			}
		},
		d(detaching) {
			if (detaching) detach(div);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			if (if_block2) if_block2.d();
			if (if_block3) if_block3.d();
			if (if_block4) if_block4.d();
		}
	};
}

// (25:4) {#if $hoveredPawnStore.hp !== undefined}
function create_if_block_5(ctx) {
	let label;
	let data;
	let t1_value = /*$hoveredPawnStore*/ ctx[0].hp + "";
	let t1;
	let t2;
	let t3_value = /*$hoveredPawnStore*/ ctx[0].maxHp + "";
	let t3;

	return {
		c() {
			label = element("label");
			label.textContent = "HP";
			data = element("data");
			t1 = text(t1_value);
			t2 = text("/");
			t3 = text(t3_value);
			attr(label, "class", "svelte-16hcikk");
			attr(data, "class", "svelte-16hcikk");
		},
		m(target, anchor) {
			insert(target, label, anchor);
			insert(target, data, anchor);
			append(data, t1);
			append(data, t2);
			append(data, t3);
		},
		p(ctx, dirty) {
			if (dirty & /*$hoveredPawnStore*/ 1 && t1_value !== (t1_value = /*$hoveredPawnStore*/ ctx[0].hp + "")) set_data(t1, t1_value);
			if (dirty & /*$hoveredPawnStore*/ 1 && t3_value !== (t3_value = /*$hoveredPawnStore*/ ctx[0].maxHp + "")) set_data(t3, t3_value);
		},
		d(detaching) {
			if (detaching) detach(label);
			if (detaching) detach(data);
		}
	};
}

// (28:4) {#if $hoveredPawnStore.xp !== undefined}
function create_if_block_4(ctx) {
	let label;
	let data;
	let t1_value = /*$hoveredPawnStore*/ ctx[0].xp + "";
	let t1;

	return {
		c() {
			label = element("label");
			label.textContent = "XP";
			data = element("data");
			t1 = text(t1_value);
			attr(label, "class", "svelte-16hcikk");
			attr(data, "class", "svelte-16hcikk");
		},
		m(target, anchor) {
			insert(target, label, anchor);
			insert(target, data, anchor);
			append(data, t1);
		},
		p(ctx, dirty) {
			if (dirty & /*$hoveredPawnStore*/ 1 && t1_value !== (t1_value = /*$hoveredPawnStore*/ ctx[0].xp + "")) set_data(t1, t1_value);
		},
		d(detaching) {
			if (detaching) detach(label);
			if (detaching) detach(data);
		}
	};
}

// (31:4) {#if $hoveredPawnStore.level !== undefined}
function create_if_block_3(ctx) {
	let label;
	let data;
	let t1_value = /*$hoveredPawnStore*/ ctx[0].level + "";
	let t1;
	let t2;
	let t3_value = /*$hoveredPawnStore*/ ctx[0].maxLevel + "";
	let t3;

	return {
		c() {
			label = element("label");
			label.textContent = "Level";
			data = element("data");
			t1 = text(t1_value);
			t2 = text("/");
			t3 = text(t3_value);
			attr(label, "class", "svelte-16hcikk");
			attr(data, "class", "svelte-16hcikk");
		},
		m(target, anchor) {
			insert(target, label, anchor);
			insert(target, data, anchor);
			append(data, t1);
			append(data, t2);
			append(data, t3);
		},
		p(ctx, dirty) {
			if (dirty & /*$hoveredPawnStore*/ 1 && t1_value !== (t1_value = /*$hoveredPawnStore*/ ctx[0].level + "")) set_data(t1, t1_value);
			if (dirty & /*$hoveredPawnStore*/ 1 && t3_value !== (t3_value = /*$hoveredPawnStore*/ ctx[0].maxLevel + "")) set_data(t3, t3_value);
		},
		d(detaching) {
			if (detaching) detach(label);
			if (detaching) detach(data);
		}
	};
}

// (34:4) {#if $hoveredPawnStore.attack !== undefined}
function create_if_block_2(ctx) {
	let label;
	let data;
	let t1_value = /*$hoveredPawnStore*/ ctx[0].attack + "";
	let t1;

	return {
		c() {
			label = element("label");
			label.textContent = "Attack";
			data = element("data");
			t1 = text(t1_value);
			attr(label, "class", "svelte-16hcikk");
			attr(data, "class", "svelte-16hcikk");
		},
		m(target, anchor) {
			insert(target, label, anchor);
			insert(target, data, anchor);
			append(data, t1);
		},
		p(ctx, dirty) {
			if (dirty & /*$hoveredPawnStore*/ 1 && t1_value !== (t1_value = /*$hoveredPawnStore*/ ctx[0].attack + "")) set_data(t1, t1_value);
		},
		d(detaching) {
			if (detaching) detach(label);
			if (detaching) detach(data);
		}
	};
}

// (37:4) {#if $hoveredPawnStore.readyToMerge !== undefined}
function create_if_block_1(ctx) {
	let label;
	let data;
	let t1_value = /*$hoveredPawnStore*/ ctx[0].readyToMerge + "";
	let t1;

	return {
		c() {
			label = element("label");
			label.textContent = "Ready to Merge";
			data = element("data");
			t1 = text(t1_value);
			attr(label, "class", "svelte-16hcikk");
			attr(data, "class", "svelte-16hcikk");
		},
		m(target, anchor) {
			insert(target, label, anchor);
			insert(target, data, anchor);
			append(data, t1);
		},
		p(ctx, dirty) {
			if (dirty & /*$hoveredPawnStore*/ 1 && t1_value !== (t1_value = /*$hoveredPawnStore*/ ctx[0].readyToMerge + "")) set_data(t1, t1_value);
		},
		d(detaching) {
			if (detaching) detach(label);
			if (detaching) detach(data);
		}
	};
}

function create_fragment(ctx) {
	let if_block_anchor;

	function select_block_type(ctx, dirty) {
		if (/*$hoveredPawnStore*/ ctx[0].id) return create_if_block;
		return create_else_block;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block = current_block_type(ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
		},
		p(ctx, [dirty]) {
			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $hoveredPawnStore;
	component_subscribe($$self, hoveredPawnStore, $$value => $$invalidate(0, $hoveredPawnStore = $$value));
	return [$hoveredPawnStore];
}

class PawnStats extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-16hcikk-style")) add_css();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default PawnStats;